export default __webpack_public_path__ + "static/media/logo1.3a4e2b15.svg";